export function lerp(start, end, amt){
    return (1 - amt) * start + amt * end
}

export function pad(x) {
    return x < 10 ? `0${x}` : x
}
